
import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

const billing_url = `${billing_expense.billing_expense_url}/${server.QUOTATIONS_ITEM}`

export const billing_expense_getAllQuotationsItemByID = (id) => {
    return httpClient.get(`${billing_url}/${id}`);
};
export const billing_expense_getAllQuotationsItem = () => {
    return httpClient.get(`${billing_url}/`);
};

export const billing_expense_addQuotationsItem = (data) => {
    return httpClient.post(`${billing_url}/`, data);
};

export const billing_expense_updateQuotationsItem = (id, data) => {
    return httpClient.put(`${billing_url}/${id}`, data);
};
export const billing_expense_deleteQuotationsItem = (id) => {
    return httpClient.delete(`${billing_url}/${id}`);
};
